// extracted by mini-css-extract-plugin
module.exports = {"column":"RecipeIngredients_column__3OzPV"};